(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["highlight-slider"] && !Shopify.designMode) return;
  try {
    




(() => {
  const instances = new WeakMap();

  function initHighlightSwiper(sectionEl) {
    if (!sectionEl || instances.get(sectionEl)) return;

    const container = sectionEl.querySelector('.highlight-swiper');
    if (!container) return;

    const slides = container.querySelectorAll('.swiper-slide');
    const hasMultiple = slides.length > 1;

    const prevEl = sectionEl.querySelector('.highlight-swiper-button-prev');
    const nextEl = sectionEl.querySelector('.highlight-swiper-button-next');

    // Wenn nur 1 Slide: keine Initialisierung, Pfeile verstecken
    if (!hasMultiple) {
      if (prevEl) prevEl.style.display = 'none';
      if (nextEl) nextEl.style.display = 'none';
      return;
    }

    const swiper = new Swiper(container, {
      // Core
      speed: 500,
      spaceBetween: 16,
      watchOverflow: true, // falls CSS/hide Navigation bei wenig Slides
      loop: true,          // nur sinnvoll bei >1 Slide (siehe hasMultiple)
      grabCursor: true,
      centeredSlides: false,
      // Anzeige
      slidesPerView: 1,
      breakpoints: {
        576: { slidesPerView: 1.2, spaceBetween: 18 },
        800: { slidesPerView: 2.1,   spaceBetween: 20 },
        1000: { slidesPerView: 3.1,   spaceBetween: 20 },
        1800:{ slidesPerView: 4.3,   spaceBetween: 24 }
      },
      // Bedienung
      keyboard: { enabled: true },
      navigation: {
        nextEl: nextEl || undefined,
        prevEl: prevEl || undefined
      },
      // Performance/Beobachter
      observer: true,
      observeParents: true,
      // Optional: Autoplay (deaktiviert im Editor)
      autoplay: false/*(Shopify && Shopify.designMode) ? false : {
        delay: 4500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      }*/,
      // Barrierefreiheit
      a11y: {
        enabled: true
      }
    });

    instances.set(sectionEl, swiper);
  }

  function destroyHighlightSwiper(sectionEl) {
    const swiper = instances.get(sectionEl);
    if (swiper && swiper.destroy) {
      swiper.destroy(true, true);
      instances.delete(sectionEl);
    }
  }

  function initAll() {
    document
      .querySelectorAll('.section--highlight-swiper')
      .forEach(initHighlightSwiper);
  }

  // Initial auf DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  // Support für Theme-Editor (Abschnitt wird neu gerendert)
  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target;
    if (el && el.classList && el.classList.contains('section--highlight-swiper')) {
      initHighlightSwiper(el);
    } else {
      // Fallback: innerhalb des geladenen Abschnitts suchen
      el.querySelectorAll?.('.section--highlight-swiper').forEach(initHighlightSwiper);
    }
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const el = e.target;
    if (el && el.classList && el.classList.contains('section--highlight-swiper')) {
      destroyHighlightSwiper(el);
    } else {
      el.querySelectorAll?.('.section--highlight-swiper').forEach(destroyHighlightSwiper);
    }
  });

  // Optional: Re-init bei Block-Änderungen im Editor (z. B. Produkt hinzugefügt)
  document.addEventListener('shopify:block:select', (e) => {
    const section = e.target.closest('.section--highlight-swiper');
    if (section) {
      destroyHighlightSwiper(section);
      initHighlightSwiper(section);
    }
  });
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();

  function initRelatedSwiper(sectionEl) {
    if (!sectionEl || instances.get(sectionEl)) return;

    const container = sectionEl.querySelector('.related-swiper');
    if (!container) return;

    const slides = container.querySelectorAll('.swiper-slide');
    const hasMultiple = slides.length > 1;

    const prevEl = sectionEl.querySelector('.related-swiper-button-prev');
    const nextEl = sectionEl.querySelector('.related-swiper-button-next');

    // Bei nur 1 Slide: Pfeile ausblenden, kein Swiper
    if (!hasMultiple) {
      if (prevEl) prevEl.style.display = 'none';
      if (nextEl) nextEl.style.display = 'none';
      return;
    }

    const swiper = new Swiper(container, {
      speed: 500,
      spaceBetween: 16,
      watchOverflow: true,
      loop: true,
      grabCursor: true,
      centeredSlides: false,
      slidesPerView: 1,
      breakpoints: {
        576: { slidesPerView: 1.2, spaceBetween: 18 },
        800: { slidesPerView: 2.1, spaceBetween: 20 },
        1200:{ slidesPerView: 3.3, spaceBetween: 24 }
      },
      keyboard: { enabled: true },
      navigation: {
        nextEl: nextEl || undefined,
        prevEl: prevEl || undefined
      },
      observer: true,
      observeParents: true,
   /*   autoplay: (window.Shopify && Shopify.designMode) ? false : {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },*/
      a11y: { enabled: true }
    });

    instances.set(sectionEl, swiper);
  }

  function destroyRelatedSwiper(sectionEl) {
    const swiper = instances.get(sectionEl);
    if (swiper && swiper.destroy) {
      swiper.destroy(true, true);
      instances.delete(sectionEl);
    }
  }

  function initAll() {
    document.querySelectorAll('.section--related-swiper').forEach(initRelatedSwiper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  // Theme-Editor Events
  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target;
    if (el?.classList?.contains('section--related-swiper')) {
      initRelatedSwiper(el);
    } else {
      el.querySelectorAll?.('.section--related-swiper').forEach(initRelatedSwiper);
    }
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const el = e.target;
    if (el?.classList?.contains('section--related-swiper')) {
      destroyRelatedSwiper(el);
    } else {
      el.querySelectorAll?.('.section--related-swiper').forEach(destroyRelatedSwiper);
    }
  });

  // Re-init bei Block-Änderungen im Editor
  document.addEventListener('shopify:block:select', (e) => {
    const section = e.target.closest('.section--related-swiper');
    if (section) {
      destroyRelatedSwiper(section);
      initRelatedSwiper(section);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
